module.exports = __webpack_public_path__ + "static/media/EventPhoto2.e57789f2.jpg";